import React, { useContext } from 'react';
import DesktopDevPageSide300x250 from '@wix/da-ads/pkg/adunits/anon/DesktopDevPageSide300x250';
import UserDesktopDevPageSide300x250 from '@wix/da-ads/pkg/adunits/user/DesktopDevPageSide300x250';
import DesktopDevPageSide300x250Atf from '@wix/da-ads/pkg/adunits/anon/DesktopDevPageSide300x250Atf';
import UserDesktopDevPageSide300x250Atf from '@wix/da-ads/pkg/adunits/user/DesktopDevPageSide300x250Atf';
import MobileDevPageSide300x250 from '@wix/da-ads/pkg/adunits/anon/MobileDevPageSide300x250';
import UserMobileDevPageSide300x250 from '@wix/da-ads/pkg/adunits/user/MobileDevPageSide300x250';
import ErrorBoundary from '../../../../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import cn from 'classnames';
import s from './Ad.scss';
const Ad = ({ block , adSafety , deviation  })=>{
    const isMobile = useContext(MobileContext);
    const showAd = useShouldRenderAdArea(adSafety);
    if (!showAd) {
        return null;
    }
    // Mobile only has BTF
    if (isMobile && block.contentType === 'ad_top') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], block.contentType === 'ad_btf' && s['btf'], block.contentType === 'ad_top' && s['atf'])
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SidebarAd"
    }, block.contentType === 'ad_top' && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['display-atf'])
    }, /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
        anon: DesktopDevPageSide300x250Atf,
        user: UserDesktopDevPageSide300x250Atf,
        safety: adSafety
    })), block.contentType === 'ad_btf' && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['display-btf'])
    }, !isMobile && /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
        anon: DesktopDevPageSide300x250,
        user: UserDesktopDevPageSide300x250,
        safety: adSafety
    }), isMobile && /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
        anon: MobileDevPageSide300x250,
        user: UserMobileDevPageSide300x250,
        safety: adSafety
    }))));
};
Ad.displayName = 'Ad';
export default Ad;
